function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M9.5 1a8.36 8.36 0 0 1 4.311 1.165 8.056 8.056 0 0 1 3.024 3.024A8.36 8.36 0 0 1 18 9.5a8.36 8.36 0 0 1-1.165 4.311 8.056 8.056 0 0 1-3.024 3.024A8.36 8.36 0 0 1 9.5 18a8.36 8.36 0 0 1-4.311-1.165 8.209 8.209 0 0 1-3.024-3.044A8.322 8.322 0 0 1 1 9.5c0-1.54.388-2.97 1.165-4.29a8.365 8.365 0 0 1 3.044-3.045A8.322 8.322 0 0 1 9.5 1z",
  stroke: "#009AD7",
  strokeWidth: 1.3,
  fill: "#009AD7"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M9.26 5v4.574L13 11.893 12.38 13 8 10.222V5z"
}));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "-1 -1 21 21",
    width: 19,
    height: 19,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Clock.c0327b74.svg";
export { ForwardRef as ReactComponent };